import { inject, provide, ref } from 'vue'

const HIGHLIGHT_KEY = Symbol('highlightTerms')

export const provideHighlightTerms = terms => provide(HIGHLIGHT_KEY, terms)

export const injectHighlightTerms = () => inject(HIGHLIGHT_KEY, null) ?? ref([])
